import { Button, Input, Label, useToast } from '@ais-ui/ui-core';
import React from 'react';
import { CustomizePopover } from './CustomizePopover';
import { ParsedReportParams, useCoverageReconfigure } from '@ais-ui/websockets';
import { useFetchOverlayData } from '../useMapReportOverlay';

interface CustomizeCoverageProps {
  report: ParsedReportParams;
  className?: string;
}

export const CustomizeCoverage = ({
  report,
  className,
}: CustomizeCoverageProps) => {
  const fetchOverlayData = useFetchOverlayData();
  const { mutate } = useCoverageReconfigure(fetchOverlayData);

  const [numberOfColors, setNumberOfColors] = React.useState(report.params.CD);
  const { toast } = useToast();

  const onApply = () => {
    mutate(
      {
        jobId: report.info?.['Job ID'] as string,
        numberOfColors,
      },
      {
        onSuccess: () => {
          toast({
            title: 'Success!',
            description: 'Customized density report successfully',
          });
        },
        onError: () => {
          toast({
            title: 'Error!',
            description: 'Error customizing density report',
            variant: 'destructive',
          });
        },
      }
    );
  };

  return (
    <CustomizePopover>
      <form className="grid grid-cols-2 gap-8 p-2 w-96">
        <div className="space-y-2">
          <Label htmlFor="num-colors">Number of Colors</Label>
          <Input
            id="num-colors"
            type="number"
            min="2"
            max="40"
            value={numberOfColors}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNumberOfColors(parseInt(event.target.value));
            }}
            className="w-full"
          />
        </div>
      </form>
      <div className="pt-6 flex justify-end">
        <Button onClick={onApply}>Apply</Button>
      </div>
    </CustomizePopover>
  );
};
